import React from 'react';

export const getClassName = (touched, invalid, visited) => {
  const defaultClass = 'settings_input';
  const invalidClasses = `invalid-input ${defaultClass}`;
  const validVlasses = `valid-input ${defaultClass}`;
  if (touched && invalid) {
    return invalidClasses;
  } else if (touched && !invalid && visited) {
    return validVlasses;
  }
  return defaultClass;
};

export const isInRange = (value, min, max) => value >= min && value <= max;
export const hasMinimum = (value, min) => value.length >= min;
export const isEmpty = (value) => !value || (/^\s+$/).test(value);

export const renderValidationIcon = (touched, invalid, visited) => {
  if (touched && !invalid && visited) {
    return (
      <i
        style={{
          color: '#a9ec82',
        }}
        className="material-icons validation-icon"
      >
        done
      </i>
    );
  }
  if (touched && invalid) {
    return (
      <i
        style={{
          color: '#ec8282',
        }}
        className="material-icons validation-icon"
      >
        close
      </i>
    );
  }
  return null;
};

export const notEmail = (email) => {
  // eslint-disable-next-line prefer-named-capture-group
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return !re.test(String(email).toLowerCase());
};
